// "Nice" numbers for tick intervals (1-2-2.5-5 pattern per decade)
const NICE_NUMBERS = [1, 2, 5, 10, 20, 25, 50, 100, 200, 250, 500, 1000, 2000, 2500, 5000];

// Target screen pixel spacing for major ticks at 100% zoom.
// 35 gives breakpoint at 70% zoom (where it switches from major=50 to major=100)
const TARGET_MAJOR_SPACING = 35;

/**
 * Finds the smallest "nice" number >= the given value.
 */
export const findNiceNumber = (value: number): number => {
  for (const nice of NICE_NUMBERS) {
    if (nice >= value) return nice;
  }
  return NICE_NUMBERS[NICE_NUMBERS.length - 1];
};

/**
 * Determines tick intervals based on zoom level to maintain consistent screen spacing.
 * Uses the user's zoom level (not the combined scale) so that at 100% zoom the ruler
 * always shows major=50 intervals, regardless of how the design fits in the viewport.
 * Uses "nice" numbers (1, 2, 5, 10, 20, 50, 100...) for clean ruler labels.
 */
export const getTickInterval = (zoom: number): { major: number; minor: number } => {
  // Calculate the design unit interval needed to achieve target screen spacing
  const rawInterval = TARGET_MAJOR_SPACING / zoom;

  // Round up to nearest "nice" number
  const major = findNiceNumber(rawInterval);

  // Minor ticks: divide major by 4 or 5 to get nice subdivisions
  // Use 5 for intervals divisible by 5 or 10, otherwise 4
  const minor = major % 5 === 0 ? major / 5 : major / 4;

  return { major, minor };
};
